import { Component } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RoutesRecognized } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './../environments/environment';
import { UtilService } from './shared/_services/util.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
declare global {
  interface Window { JSONData: any; }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  subscription: Subscription;
  imageSrc: string;
  title = 'app';
  user: any = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')) : null;
  lsaRoutes = ['hca-management', 'user-management'];
  allowedRoutes = ['profile-management'];

  history = [];
  constructor(private router: Router, public translate: TranslateService, private utilService: UtilService) {
    translate.setDefaultLang('en');
    translate.use('en');

      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {
        this.history = [...this.history, urlAfterRedirects];
        this.utilService.setRouterEvents = this.history;
      });

    router.events.subscribe((event: any) => {
      let user: any = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')) : null;
      if (event instanceof NavigationEnd) {
        // let routeData = {
        //   previousUrl: this.router.url,
        //   currentUrl: event.url
        // }
        // this.utilService.setRouterEvents = routeData;
        let url = event.url.split('/', 2)[1];
        if (this.allowedRoutes.indexOf(url) > -1) {
          router.navigate([event.url]);
        } else if (user && user.userRoleId !== 11 && this.lsaRoutes.indexOf(url) > -1) {
          router.navigate(['/hotel-management']);
        } else if (user && user.userRoleId == 11 && this.lsaRoutes.indexOf(url) == -1) {
          router.navigate(['/hca-management']);
        } else if (user && user.userRoleId && ['login', ''].indexOf(url) == -1) {
          router.navigate([event.url]);
        } else if(event.url=="/"){ //Si es concierge y entra a / debemos redirigir a /concierge
          let user = JSON.parse(localStorage.getItem('loggedInUser'));
          if(user && user.userRoleName === 'Concierge') {
            this.router.navigate(['/concierge']);
          }
        } else if(event.url=="/") { //Si es SA y entra a / debemos redirigir a /smartAgents
          let user = JSON.parse(localStorage.getItem('loggedInUser'));
          if(user && user.userRoleName === 'Smart Agent') {
            this.router.navigate(['/smartAgents']);
          } else if(user && user.userRoleName === 'Reception') {
            this.router.navigate(['/reception']);
          } 
        }
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.translate.setDefaultLang('en');
    this.subscription = this.utilService.notifyObservable$.subscribe((res) => {
      if (res.hasOwnProperty('option') && res.option === 'onChange') {
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use(res);
        // perform your other action from here

      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts